import {
  SchoolOutlined,
  SettingsOutlined,
  StructureOutlined,
  CalendarScheduleYearOutlined,
  ListNumberedOutlined,
  LogoutOutlined,
  BookStarOutlined,
  BadgeStarOutlined,
  StaffMemberOutlined,
  SwitchArrowsOutlined,
  SpannerOutlined,
  TickCrossOutlined,
  GridOutlined,
  InsightsOutlined,
} from "@toddle-edu/ds-icons";

import { ADMIN_PORTAL_ITEM_KEYS } from "./AdminPortalConfig";

// POC 1 only — Admission Account Portal sidebar items grouped into 3
// sections. Each item routes to a placeholder page that only renders the
// title, except ADMISSION_UNIT_SETUP_KEY which is a link-out to the existing
// /admissions/unitsAndSchools page.

export const ADMISSION_UNIT_SETUP_KEY = "admissionUnitSetup";

export const ADMISSION_ACCOUNT_SETUP_ITEM_KEYS = {
  ACCOUNT_INFORMATION: "accountInformation",
  ORGANIZATIONAL_STRUCTURE: "organizationalStructure",
  SCHOOL_INFORMATION: "schoolInformation",
  ACADEMIC_YEARS: "academicYears",
  GRADE_LEVELS: "gradeLevels",
  LOGIN_CONFIGURATION: "loginConfiguration",
  ADMISSION_UNIT_SETUP: ADMISSION_UNIT_SETUP_KEY,
  ACADEMIC_TYPES_SETUP: "academicTypesSetup",
  SUBSCRIPTION_PLAN: "subscriptionPlan",
};

export const ADMISSION_MEMBERS_ITEM_KEYS = {
  STAFF: "staff",
  ROSTER_SYNC: "rosterSync",
};

export const ADMISSION_OTHER_SETTINGS_ITEM_KEYS = {
  ROLES_AND_PERMISSIONS: "rolesAndPermissions",
  TOGGLE_MODULES: "toggleModules",
  INTEGRATIONS: "integrations",
  USER_ACTIVITY_LOGS: "userActivityLogs",
};

export const ADMISSION_ACCOUNT_SETUP_ITEMS = [
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.ACCOUNT_INFORMATION,
    labelLocale: "common:account_information",
    Icon: SettingsOutlined,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.ORGANIZATIONAL_STRUCTURE,
    labelLocale: "common:organisational_structure",
    Icon: StructureOutlined,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.SCHOOL_INFORMATION,
    labelLocale: "common:school_information",
    Icon: SchoolOutlined,
    hasChevron: true,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.ACADEMIC_YEARS,
    labelLocale: "common:academic_year_plural",
    Icon: CalendarScheduleYearOutlined,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.GRADE_LEVELS,
    labelLocale: "common:grade_levels",
    Icon: ListNumberedOutlined,
    hasChevron: true,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.LOGIN_CONFIGURATION,
    labelLocale: "common:login_configuration",
    Icon: LogoutOutlined,
    hasChevron: true,
  },
  {
    key: ADMISSION_UNIT_SETUP_KEY,
    labelLocale: "common:admission_unit_setup",
    Icon: SchoolOutlined,
    // link-out — handled by sidebar click handler.
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.ACADEMIC_TYPES_SETUP,
    labelLocale: "common:academic_types_setup",
    Icon: BookStarOutlined,
  },
  {
    key: ADMISSION_ACCOUNT_SETUP_ITEM_KEYS.SUBSCRIPTION_PLAN,
    labelLocale: "common:subscription_plan",
    Icon: BadgeStarOutlined,
  },
];

export const ADMISSION_MEMBERS_ITEMS = [
  {
    key: ADMISSION_MEMBERS_ITEM_KEYS.STAFF,
    labelLocale: "common:staff",
    Icon: StaffMemberOutlined,
  },
  {
    key: ADMISSION_MEMBERS_ITEM_KEYS.ROSTER_SYNC,
    labelLocale: "integration:roster_sync",
    Icon: SwitchArrowsOutlined,
  },
];

export const ADMISSION_OTHER_SETTINGS_ITEMS = [
  {
    key: ADMISSION_OTHER_SETTINGS_ITEM_KEYS.ROLES_AND_PERMISSIONS,
    labelLocale: "common:roles_and_permissions",
    Icon: SpannerOutlined,
    hasChevron: true,
  },
  {
    key: ADMISSION_OTHER_SETTINGS_ITEM_KEYS.TOGGLE_MODULES,
    labelLocale: "common:toggle_modules",
    Icon: TickCrossOutlined,
  },
  {
    key: ADMISSION_OTHER_SETTINGS_ITEM_KEYS.INTEGRATIONS,
    labelLocale: "integration:integration",
    Icon: GridOutlined,
    hasChevron: true,
  },
  {
    key: ADMISSION_OTHER_SETTINGS_ITEM_KEYS.USER_ACTIVITY_LOGS,
    labelLocale: "common:user_activity_logs",
    Icon: InsightsOutlined,
  },
];

// All items that get a sibling placeholder route under /admissions/. Excludes
// ADMISSION_UNIT_SETUP_KEY (link-out only).
export const ADMISSION_PLACEHOLDER_ITEMS = [
  ...ADMISSION_ACCOUNT_SETUP_ITEMS.filter(
    item => item.key !== ADMISSION_UNIT_SETUP_KEY
  ),
  ...ADMISSION_MEMBERS_ITEMS,
  ...ADMISSION_OTHER_SETTINGS_ITEMS,
];

export const getAdmissionItemPath = key => {
  if (key === ADMISSION_UNIT_SETUP_KEY) return "/admissions/unitsAndSchools";
  return `/admissions/${key}`;
};

// Back-compat helper retained for existing callers.
export const getAdmissionAccountSetupPath = key =>
  getAdmissionItemPath(key);

export const UNITS_AND_SCHOOLS_KEY = ADMIN_PORTAL_ITEM_KEYS.UNITS_AND_SCHOOLS;
